export function getAuthorName(value) {
  return `${value?.created_by_user?.vaxiom_person?.first_name || 'Support'} ${
    value.created_by_user?.vaxiom_person?.last_name || ''
  }`
}
